export function formatConditionLabel(value: string) {
  return value
    .split('-')
    .map((part) => {
      if (part.toUpperCase() === 'V2') {
        return 'V2';
      }
      return part.charAt(0) + part.slice(1).toLowerCase();
    })
    .join(' ');
}

export function formatApplyTypeLabel(value: string) {
  return value
    .split('-')
    .map((part) => part.charAt(0) + part.slice(1).toLowerCase())
    .join(' ');
}
